export default str => (new DOMParser().parseFromString(str.replace( /(<([^>]+)>)/ig, ''), "text/html")).body.innerText;